import RadioButtonGroupWithClearButton from '../RadioGroupWithClearButton';

interface YesNoRadioGroupProps {
  title: string;
  name: string;
  value: string | undefined | null;
  required?: boolean;
  handleRadioChange: (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClear: () => void;
  error?: boolean;
  helperText?: string;
  testId?: string;
}

export const YesNoRadioGroupWithClearButton = ({
  title,
  name,
  value,
  required,
  error,
  helperText,
  handleRadioChange,
  handleClear,
  testId,
}: YesNoRadioGroupProps) => {
  return (
    <RadioButtonGroupWithClearButton
      title={title}
      name={name}
      options={{ Yes: '0', No: '1' }}
      value={value}
      required={required}
      handleRadioChange={handleRadioChange}
      handleClear={handleClear}
      error={error}
      helperText={helperText}
      testId={testId}
    />
  );
};
